<script>import { createEventDispatcher, getContext } from "svelte";
import FieldContainer from "./helper/FieldContainer.svelte";
import { createFieldContext } from "./helper/field.js";
import PickerInput from "./helper/PickerInput.svelte";
import DatePicker from "./helper/DatePicker.svelte";
import {
  getPlaceHolder,
  getParser,
  getIntlDateTimeFormatOptions,
  getFormatter,
  WeekNumberSystem
} from "../../util/date-time-util.js";
export let name = void 0;
export let label;
export let callToInput = void 0;
export let assistText = void 0;
export let story = "filled.dateTime";
export let value = void 0;
export let error = void 0;
export let disabled = false;
export let format = void 0;
export let date = void 0;
export let time = void 0;
export let precision = void 0;
export let system = WeekNumberSystem.ISO8601;
export let control = void 0;
export let locale = void 0;
export const context = void 0;
const valueFormat = value !== void 0 && value.toPrecision ? "epoch" : "iso";
date = date !== void 0 ? date : control ? control.input.properties?.date ?? true : true;
time = time !== void 0 ? time : control ? control.input.properties?.time ?? false : false;
precision = precision !== void 0 ? precision : control ? control.input.properties?.precision ?? "minute" : "minute";
format = format !== void 0 ? format : control ? control.input.properties?.format ?? valueFormat : valueFormat;
const dispatch = createEventDispatcher();
const contextKey = createFieldContext(name, value, error, disabled, value === void 0, "");
let ctx = getContext(contextKey);
let pickerOpen = false;
const originalAssistText = assistText;
const dateTimeFormat = date ? time ? `date.${precision}` : "day" : precision;
const dateTimeOptions = getIntlDateTimeFormatOptions(dateTimeFormat);
let _parser;
let _formatter;
let pickerInputAPI;
const valueInMillis = value !== void 0 && value.toPrecision;
let valueAsDate = value !== void 0 ? value.toPrecision ? new Date(value) : new Date(value.getTime()) : void 0;
const handleNewValue = () => {
  ctx.detail?.set(valueAsDate ? formatter()(valueAsDate) : void 0);
  const newValue = valueAsDate ? valueInMillis ? valueAsDate.getTime() : valueAsDate : void 0;
  if (newValue !== value) {
    value = newValue;
    dispatch("changed", { name, value });
  }
};
const toFormValue = (value2) => {
  if (value2 !== void 0) {
    if (format === "epoch") {
      return (value2.toPrecision ? value2 : value2.getTime()).toString();
    } else {
      return (value2.toPrecision ? new Date(value2) : value2).toISOString();
    }
  } else {
    return void 0;
  }
};
$: {
  ctx.value.set(toFormValue(value));
  ctx.error.set(error);
  ctx.disabled.set(disabled);
  ctx.empty.set(value === void 0);
  valueAsDate = value !== void 0 ? value.toPrecision ? new Date(value) : new Date(value.getTime()) : void 0;
  ctx.detail?.set(valueAsDate ? formatter()(valueAsDate) : void 0);
}
$:
  props = {
    label,
    callToInput,
    assistText,
    story,
    contextKey
  };
const parser = () => {
  if (!_parser) {
    _parser = getParser(locale ?? navigator.language, system, dateTimeOptions);
  }
  return _parser;
};
const formatter = () => {
  if (!_formatter) {
    _formatter = getFormatter(locale ?? navigator.language, system, dateTimeOptions);
  }
  return _formatter;
};
ctx.detail?.set(valueAsDate ? formatter()(valueAsDate) : void 0);
const onDatePicked = (ev) => {
  const pickedValue = ev.detail.value ? ev.detail.value[0] : void 0;
  if (pickedValue) {
    valueAsDate = pickedValue;
    console.log(`DateTime ${name} onDatePicked valueAsDate=`, valueAsDate);
    handleNewValue();
  }
  pickerOpen = false;
  ctx.activity.set(false);
  ctx.focus.set(false);
};
const onStateChange = (ev) => {
  if (ev.detail.changes.focus === true) {
    pickerOpen = true;
    assistText = getPlaceHolder(locale ?? navigator.language, dateTimeOptions);
  }
  if (ev.detail.changes.focus === false) {
    pickerOpen = false;
    assistText = originalAssistText;
  }
  dispatch("state", ev.detail);
};
const onInputChange = (ev) => {
  const date2 = parser()(ev.detail.value);
  if (date2) {
    valueAsDate = date2;
    console.log(`DateTime ${name} onInputChange valueAsDate=`, valueAsDate);
    handleNewValue();
  }
};
</script>

<div class="dateTime-field-container">
	<FieldContainer {...props}>
		<svelte:fragment slot="input">
			<PickerInput
				{contextKey}
				on:state={onStateChange}
				on:input={onInputChange}
				bind:api={pickerInputAPI}
			/>
		</svelte:fragment>
	</FieldContainer>
	{#if pickerOpen}
		<DatePicker
			weeks={true}
			value={[valueAsDate, undefined]}
			pick={'start'}
			on:changed={onDatePicked}
			on:action={() => {
				ctx.activity.set(true);
			}}
		/>
	{/if}
</div>

<style>
	div.dateTime-field-container {
		--core-icon-calendar: '\f073';
		--core-icon-clock: '\f017';

		--lead-icon: var(--core-icon-calendar) !important;
	}
</style>
